import React from 'react';
// import {render as reactRender, unmount} from 'rc-util/lib/React/render';
import DialogBox from './DialogBox';
import { unstableSetRender } from '../config-provider/UnstableContext';
const destroyFns = [];
function renderDialogBox(config) {
    const reactRender = unstableSetRender();
    let unmount;
    const currentConfig = Object.assign(Object.assign({}, config), { visible: true, onClose: close });
    const container = config.getContainer
        ? (typeof config.getContainer === 'function' ? config.getContainer() : config.getContainer)
        : document.createDocumentFragment();
    function render(dialogConfig) {
        setTimeout(() => {
            unmount = reactRender(<DialogBox {...dialogConfig}/>, container);
        });
    }
    function destroy(...args) {
        const triggerCancel = args.some(param => param && param.triggerCancel);
        if (config.onCancel && triggerCancel) {
            // @ts-ignore
            config.onCancel(...args);
        }
        for (let i = 0; i < destroyFns.length; i++) {
            const fn = destroyFns[i];
            if (fn === close) {
                destroyFns.splice(i, 1);
                break;
            }
        }
        if (unmount) {
            unmount();
        }
    }
    function close(...args) {
        render(Object.assign(Object.assign({}, currentConfig), { visible: false, afterClose: () => {
                if (typeof config.afterClose === 'function') {
                    config.afterClose();
                }
                destroy.apply(this, args);
            } }));
    }
    render(currentConfig);
    destroyFns.push(close);
    return { destroy: close };
}
export function destroyAll() {
    while (destroyFns.length) {
        const close = destroyFns.pop();
        if (close) {
            close();
        }
    }
}
export function confirm(config) {
    return renderDialogBox(Object.assign(Object.assign({}, config), { type: 'confirm', cancelBtn: true }));
}
export function success(config) {
    return renderDialogBox(Object.assign(Object.assign({}, config), { type: 'success', cancelBtn: false, okText: config.okText }));
}
export function info(config) {
    return renderDialogBox(Object.assign(Object.assign({}, config), { type: 'info', cancelBtn: false, okText: config.okText }));
}
export function warning(config) {
    return renderDialogBox(Object.assign(Object.assign({}, config), { type: 'warning', cancelBtn: false, okText: config.okText }));
}
export function error(config) {
    return renderDialogBox(Object.assign(Object.assign({}, config), { type: 'error', cancelBtn: false, okText: config.okText }));
}
